const LOCATION_DRAGON_AVATAR = "/assets/81fce47cc757.png";

/**
 * Dezenter Fallback für lazy geladene Seiten. Das bereitgestellte Drachenmotiv
 * kennzeichnet einen Seitenwechsel und respektiert reduzierte Bewegung.
 */
export default function ImmozwergPageLoader() {
  return (
    <main
      className="min-h-[40vh] flex items-center justify-center bg-[#faf8f5]"
      role="status"
      aria-live="polite"
      aria-label="Seite wird geladen: Immozwerg wechselt die Location"
    >
      <div className="flex flex-col items-center gap-3 text-center">
        <div className="flex h-44 w-80 items-center justify-center" aria-hidden="true">
          <img
            src={LOCATION_DRAGON_AVATAR}
            alt=""
            width={1063}
            height={612}
            className="immozwerg-loader-dragon w-64 max-w-full object-contain sm:w-72"
            decoding="async"
          />
        </div>
        <p className="text-sm font-semibold text-[#631172]">Immozwerg wechselt die Location …</p>
      </div>
    </main>
  );
}
